import React from 'react';
import PropTypes from 'prop-types';
import './Button.scss';

const Button = ({
    text,
    onClick,
    type,
    marginTop = 10,
    marginBottom = 10,
    disabled = false,
    isUpperCase = false,
    heapAttribute,
    ...otherProps
}) => {
    return (
        <button
            disabled={disabled}
            data-heap={heapAttribute}
            style={{
                marginTop,
                marginBottom
            }}
            className={`button ${type}`}
            onClick={onClick}
            {...otherProps}>
            {isUpperCase ? text.toUpperCase() : text}
        </button>
    );
};

Button.propTypes = {
    text: PropTypes.string.isRequired,
    onClick: PropTypes.func
};

export default Button;



// WEBPACK FOOTER //
// ./src/components/Button/Button.jsx